<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>Nossa Missão</h1>
                        <span>Estamos em uma missão para tornar a escrita acadêmica em inglês fácil para todos</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="who_we_are_sections">
        <div class="container">
            <div class="row column_reverse">
                <div class="col-lg-8">
                    <div class="whot_we_are_content about_us_dots">
                        <h2>Sobre nós</h2>
                        <div class="HeadingSubLine"></div>
                        <p>A Trinka IA é um assistente de correção gramátical e aprimoramento de linguagem de geração avançada
                            e projetado para redação acadêmica e técnica. Ele foi desenvolvido por uma equipe de linguistas,
                            engenheiros e cientistas de dados com um profundo desejo de criar um futuro de comunicação sem
                            barreiras. Construímos nosso assistente de redação para apoiar todos os tipos de pessoas em todos
                            os tipos de comunicação, desde conversas pessoais a acadêmicas e cotidianas. </p>
                        <p>A Trinka IA foi desenvolvida pela Enago e faz parte do Crimson Interactive Group, uma empresa multinacional
                            com 15 anos de experiência global. Crimson tem presença em mais de 125 países com mais de 200
                            clientes, 600 funcionários, 5000 empreiteiros e 10 escritórios internacionais localizados em
                            Tóquio, Pequim, Seul, Nova Jersey, Londres, etc.</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="../../../assets/images/whoWeAre_aboutus.png" alt="about us">
                    </div>
                </div>
            </div>

            <div class="row column_reverse prodcutName_sections">
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="../../../assets/images/TrinkaD'Cunha.jpg" alt="Trinka D'Cunha">
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="whot_we_are_content">
                        <h2>A história por trás do nome</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Acreditamos em honrar inspiração, dedicação e visão, por isso fez todo sentido nomear nossa mais
                            recente criação de nossa
                            <strong>Linguista Líder Trinka D'Cunha, que liderou</strong> o Projeto desde o 1º Dia até se tornar realidade.
                            Com a Trinka IA, ela deu um passo gigante em direção à sua missão de remover a linguagem como
                            uma barreira à comunicação eficaz do conhecimento.</p>
                        <p>Nossa equipe robusta de profissionais dedicados foi igualmente crucial para projetar esta ferramenta
                            altamente avançada de correção de linguagem e gramática. Nosso produto inovador é uma prova dos
                            anos de dedicação e colaborações criativas. Nunca deixamos de reconhecer que a Trinka não poderia
                            ter sido possível se não fosse pela experiência e determinação de cada membro.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="make_in_india_section">
        <div class="made_in_india_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="made_in_india_content">
                        <h2>Feito na Índia</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Queremos colocar a Índia no mapa! A Índia é bem conhecida por seu rápido crescimento no espaço de
                            Tecnologia da Informação, que o tornou um dos principais centros de TI do mundo.</p>
                        <p>Enquanto a Índia continua a crescer rapidamente, raramente há um produto indiano de TI que marca
                            no mercado global de massa - estamos determinados a mudar isso. Com a Trinka, temos a bola rolando.
                            Trinka - projetada e desenvolvida completamente na Índia - está pronto para ser referência no
                            universo dinâmico da Inteligência Artificial e processamento de linguagem natural.</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="made_in_india_img">
                        <img src="../../../assets/images/madeInIndia.png" alt="made in india">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_crimson_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="about_crimson_content">
                        <h2>Sobre Crimson</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Fundada em 2005, a Crimson Interactive é uma empresa multinacional reconhecida como líder global
                            em soluções de pesquisa e publicação e o parceiro preferido para pesquisadores, editores, universidades
                            e empresas corporativas. Tem 200k clientes em mais de 125+ países. Os clientes da Crimson incluem
                            universidades reconhecidas internacionalmente, como MIT, Princeton, Columbia e University of
                            Oxford e Corporações como Toyota, Wiley, Elsevier, Capgemini, Panasonic, Fujitsu, Guinness World
                            Records e Hitachi.</p>
                        <p>Crimson possui inúmeras marcas de sucesso, como Enago, Ulatus, Voxtab, Trinka.ai e Enago Life Sciences.
                            As áreas de especialização da Crimson abrangem soluções de publicação científica, e-learning,
                            localização, comunicações médicas, inteligência artificial e soluções de mídia. É também um parceiro
                            global de comunicações médicas para empresas de saúde e biofarmacêutica. Crimson tem uma ampla
                            presença global com seus escritórios em 10 principais locais internacionais - Tóquio, Seul, Pequim,
                            Istambul, Xangai, Londres, Nova Jersey e Nova York.</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about_crimson_img">
                        <img src="../../../assets/images/aboutCrimson.jpg" alt="about crimson">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="crimson_brand_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="crimson_brand_content">
                        <h2>Nossas Marcas</h2>
                        <div class="HeadingSubLine"></div>
                        <ul>
                            <li>
                                <a href="https://www.enago.com/" class="enago_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/enago-crimson.png" alt="enago crimson">
                                    <div class="text_overlay">
                                        <p>Serviços de Edição
                                            <br /> de Idiomas</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.ulatus.com/" class="ulatus_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/ulatus-crimson.png" alt="ulatus">
                                    <div class="text_overlay">
                                        <p>Serviços de
                                            <br /> Tradução</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.voxtab.com/" class="voxtab_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/voxtab-crimson.png" alt="voxtab">
                                    <div class="text_overlay">
                                        <p>Serviços de
                                            <br /> Transcrição</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://cloud.trinka.ai/signup?_rg=PT" class="trinka_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/trinka-crimson.png" alt="trinka">
                                    <div class="text_overlay">
                                        <p>Assistente de correção
                                            <br /> gramatical e redação</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://lifesciences.enago.com/" class="lifes_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/lifes-crimson.png" alt="enago lifescience">
                                    <div class="text_overlay">
                                        <p>Publicações
                                            <br /> Médicas</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="global_offices">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Nossa Presença Global</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Temos uma presença em todo o mundo para facilitar a disponibilidade de nossos serviços para a comunidade
                        de pesquisa.</p>
                    <div class="global-presence-wrap mart-20">
                        <div class="global-maps" style="position: relative;">
                            <div class="row">
                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap usa marr-10" id="usa" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">New Jersey, USA</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap usa padb-20" id="usaview">
                                    <div class="row">
                                        
                                        <div class="col-md-12 col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>New Jersey, USA</h3>
                                                <p class="marb-10">
                                                    <br>&nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap korea marr-20" id="korea" onclick="viewlocation(id)">

                                    <div class="map-box"></div>
                                    <div class="location-name">Seoul, Korea </div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap korea padb-20" id="koreaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Seoul, Korea</h3>
                                            <p>Crimson Interactive Korea Co., Ltd.
                                                <br> #803-74, 1-Dong, 775, Gyeongin-ro, Yeongdeungpo-gu, Seoul, Republic of Korea
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap china marr-20" id="china" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Beijing / Shanghai, China</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap china padb-20" id="chinaview">
                                    <div class="row">
                                        <div class="col-md-6  col-sm-6  col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Beijing, China</h3>
                                                <p class="marb-10">Room 607, Attempt Center, No. A6 Zhongguancun South Street, Haidian District,
                                                    Beijing, China - 100086
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6  col-sm-6 col-xs-12  global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Shangai, China</h3>
                                                <p class="marb-10">Room 101, No. 110, Tianlinshiyicun, Xuhui District, Shanghai 200233
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap japan marr-20" id="japan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Tokyo, Japan</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap japan padb-20" id="japanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Tokyo, Japan</h3>
                                            <p class="marb-10">Crimson Interactive K.K.
                                                <br> 4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo, 101-0021,
                                                Japan
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap india active" id="india" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Mumbai, India</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap india padb-20 show" id="indiaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Mumbai, India</h3>
                                            <p class="marb-10">Crimson Interactive
                                                <br> 1001, 10th Floor, Techniplex - II, Veer Savarkar Flyover, S. V. Road, Goregaon
                                                (W), Mumbai 400062, India
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap uk" id="uk" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">London, United Kingdom</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap uk padb-20" id="ukview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>London, United Kingdom</h3>
                                            <p class="marb-10">Woodberry House, 2 Woodberry Grove, Finchley, London, N12 0DR, United Kingdom
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap turkey" id="turkey" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Istanbul, Turkey</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap turkey padb-20" id="turkeyview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Istanbul, Turkey</h3>
                                            <p class="marb-10">Levent Mah. Ulgen Sok. No:52 Besiktas Istanbul, TURKEY
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap taiwan" id="taiwan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Taipei,
                                        <br> Taiwan</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap taiwan padb-20" id="taiwanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Taipei, Taiwan</h3>
                                            <p class="marb-10">
                                                2F, No. 40, Ln 91, Sec.1,
                                                <br> Neihu Road, Neihu Dist., Taipei City 11441, Taiwan.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="no_of_glance_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="glance_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>Números num relance</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="glance_contents">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/Aboutus-author.png" alt="about us">
                                    </div>
                                    <p>Mais de 2 milhões de autores</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/aboutus_satisfy.png" alt="about">
                                    </div>
                                    <p>99.45%
                                        <br /> de satisfação do cliente</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/aboutus_degree_cap.png" alt="about">
                                    </div>
                                    <p>Mais de 2.000 especialistas em PhD / Mestrado</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/globe.svg" alt="globe" style="width: 40px;">
                                    </div>
                                    <p>Mais de 125 países</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_us_our_client">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Nossos Clientes</h2>
                    <div class="HeadingSubLine"></div>
                    <ul class="nav nav-tabs" role="tablist">
                        <li>
                            <a class="nav-link active" data-toggle="tab" href="#UniversityPartners" role="tab">Parceiros universitários</a>
                        </li>
                        <li>
                            <a class="nav-link" data-toggle="tab" href="#Corporates_sections" role="tab">Corporações</a>
                        </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane active" id="UniversityPartners" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="../../../assets/images/client_logos/Columbia_Univ_207.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Duke_Univ.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Priceton_Univ.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Purdue_Univ.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/MIT.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Technical-University-of-Denmark.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Univ_of_Birmingham.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Yonsei_University.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/University_of_Gassgow.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Washinton_State_Univ.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Korea_University.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/KyotoUniversityLogo.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Peking-University.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Tsinghua_University79.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/University_of_Tokyo.png" loading="lazy"  decoding="async" alt="universities">
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane" id="Corporates_sections" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/wiley-logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/IBMWatson-logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/bombay-stock.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/Netflix-logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/toyota_log.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/guiness_world_Recodos.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/oup.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/Johnson-logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/sony_logo.png" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/bankofjapan.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/abbott.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/FujiTsu_logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/DowJones-logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/canon_logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/pfizer-logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/sanofi_logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/RBS_logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/iifl-logo.png" loading="lazy"  decoding="async" alt="corporates">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="awards_certifications">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>
                        <span></span>Prêmios e Certificações</h2>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/golden-bridge-medal.png" alt="golden bridge">
                                    </div>
                                    <p>The Golden Bridge Awards For Best Entrepreneur (Women)</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/pharma-award.png" alt="pharma">
                                    </div>
                                    <p>APAC CIO Outlook Top 10 Pharma & Life Science Tech Solution Providers</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/ksci.png" alt="ksci">
                                    </div>
                                    <p>Korea
                                        <br /> Satisfaction Consumer
                                        <br /> Index
                                    </p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/bizz-award.png" alt="bizz">
                                    </div>
                                    <p>Bizz Award For Business Excellence</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/qms-award.png" alt="qms">
                                    </div>
                                    <p>The World Quality
                                        <br /> Commitment Award</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/red-awards.png" alt="red awards">
                                    </div>
                                    <p>Red Herring Top 100 Asia
                                        <br /> and Global Awards!</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/sme-award.png" alt="sme">
                                    </div>
                                    <p>Google SME Award</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="our_values_slider">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>
                        <span></span>Nossos Valores</h2>
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Responsabilidade Social</h4>
                                <p>Acreditamos que nossas ações têm impacto na sociedade e no meio ambiente por meio de comportamentos
                                    éticos e transparentes, contribuindo para o desenvolvimento sustentável.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Respeito</h4>
                                <p>Nós praticamos o valor do respeito enquanto lidamos com a cultura, as pessoas e o meio ambiente.
                                    O respeito por nossos alunos e professores se reflete em nossos esforços inabaláveis
                                    para cumprir suas expectativas; e praticar as virtudes da polidez, paciência e sensibilidade
                                    para diferentes origens culturais.</p>
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Wow</h4>
                                <p>O valor “Wow” está no núcleo do nosso sistema de valores. Isso significa entregar nosso aprendizado
                                    de uma maneira que exceda todas as expectativas. Nós tentamos persistentemente alcançar
                                    o Wow através da melhoria da comunicação e da oferta de aprendizagem inovadora.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Kaizen</h4>
                                <p>O valor de “Kaizen”, que significa melhoria contínua, forma o núcleo de todo o nosso ensino.
                                    A essência do Kaizen é a inovação, e tanto a tecnologia quanto o esforço humano servem
                                    como impulsionadores fundamentais para a inovação através do aperfeiçoamento constante.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Inovação</h4>
                                <p>Acreditamos na transformação de uma prática estabelecida que melhore nossa missão, melhorando
                                    o aprendizado para nossos alunos.</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Simplicidade</h4>
                                <p>Simplicidade significa nosso foco em fornecer excelência em qualidade da maneira mais eficaz
                                    por meio de processos simples apoiados por tecnologia de ponta. Isso se reflete em nossa
                                    interface fácil de usar, website fácil de navegar, termos e condições de serviço claros
                                    e serviços personalizáveis.</p>
                            </div>
                        </div>

                    </div>
                    <div class="slider_background_shadow"></div>

                </div>
            </div>
        </div>


    </div>

    <div class="about_us_footer_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="footer_sections_abouts">
                        <p>A rápida evolução da tecnologia e nuances da linguagem no mundo fazem você querer contribuir com
                            suas ideias originais e experiêcias profissionais? Se sua resposta for "Sim", então combinamos.
                            Vamos conquistar novos objetivos juntos!</p>
                        <a href="https://www.trinka.ai/pt/workwithus" target="_blank">Junte-se a nós</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>